import '../../App.css';
import { ActionGroup, Item, Flex, Button, TextArea, DialogTrigger, ActionButton, AlertDialog } from '@adobe/react-spectrum';
import { InputNumber } from "antd";
import { logTweakingSetting, logAllTweakingSettings, logFinalTweakingSetting } from '../../logging';
import { useState } from 'react';

function TweakingToolbar({ ...properties }) {

    const [prevLevel, setPrevLevel] = useState('');
    const [prevCondition, setPrevCondition] = useState(properties.condition);

    function submitSettings() {
        let settings = {}

        if (properties.condition === 'time') {
            settings = {
                timestamp: Date.now(),
                pass: properties.pass,
                workerId: properties.workerId,
                participantId: properties.participantId,
                experiment: properties.experiment,
                condition: properties.condition,
                lowFrustration: properties.lowTime,
                mediumFrustration: properties.medTime,
                highFrustration: properties.highTime,
                additionalComments: properties.commentsTime
            }
        }
        else if (properties.condition === 'redact') {
            settings = {
                timestamp: Date.now(),
                pass: properties.pass,
                workerId: properties.workerId,
                participantId: properties.participantId,
                experiment: properties.experiment,
                condition: properties.condition,
                lowFrustration: properties.lowRedact,
                mediumFrustration: properties.medRedact,
                highFrustration: properties.highRedact,
                additionalComments: properties.commentsRedact
            }
        }

        else if (properties.condition === 'trailing') {
            settings = {
                timestamp: Date.now(),
                pass: properties.pass,
                workerId: properties.workerId,
                participantId: properties.participantId,
                experiment: properties.experiment,
                condition: properties.condition,
                lowFrustration: properties.lowSize,
                mediumFrustration: properties.medSize,
                highFrustration: properties.highSize,
                additionalComments: properties.commentsSize
            }
        }
        
        logAllTweakingSettings(settings);

        if (properties.pass < 2) {
            logTweakingSetting(properties.participantId, settings, properties.callbacks);
        }

        else {

            let finalSettings = {
                timestamp: Date.now(),
                pass: properties.pass,
                workerId: properties.workerId,
                participantId: properties.participantId,
                experiment: properties.experiment,
                condition: properties.condition,

                lowRedact: properties.lowRedact,
                medRedact: properties.medRedact,
                highRedact: properties.highRedact,
                commentsRedact: properties.commentsRedact,

                lowTime: properties.lowTime,
                medTime: properties.medTime,
                highTime: properties.highTime,
                commentsTime: properties.commentsTime,

                lowSize: properties.lowSize,
                medSize: properties.medSize,
                highSize: properties.highSize,
                commentsSize: properties.commentsSize
            }

            logFinalTweakingSetting(properties.participantId, finalSettings, properties.callbacks);
        }
    }

    function changeFrustrationLevel(e) {
        if (e === prevLevel) {
            return;
        }

        let settings = {}
        if (properties.condition === 'time') {
            settings = {
                timestamp: Date.now(),
                pass: properties.pass,
                workerId: properties.workerId,
                participantId: properties.participantId,
                experiment: properties.experiment,
                condition: properties.condition,
                lowFrustration: properties.lowTime,
                mediumFrustration: properties.medTime,
                highFrustration: properties.highTime,
                additionalComments: properties.commentsTime
            }
        }

        else if (properties.condition === 'redact') {
            settings = {
                timestamp: Date.now(),
                pass: properties.pass,
                workerId: properties.workerId,
                participantId: properties.participantId,
                experiment: properties.experiment,
                condition: properties.condition,
                lowFrustration: properties.lowRedact,
                mediumFrustration: properties.medRedact,
                highFrustration: properties.highRedact,
                additionalComments: properties.commentsRedact
            }
        }

        else if (properties.condition === 'trailing') {
            settings = {
                timestamp: Date.now(),
                pass: properties.pass,
                workerId: properties.workerId,
                participantId: properties.participantId,
                experiment: properties.experiment,
                condition: properties.condition,
                lowFrustration: properties.lowSize,
                mediumFrustration: properties.medSize,
                highFrustration: properties.highSize,
                additionalComments: properties.commentsSize
            }
        }
        setPrevLevel(e);
        properties.setSelectedLevel(e);
        logAllTweakingSettings(settings);
    }

    function changeCondition(e) {
        if (e === prevCondition) {
            return;
        }

        let settings = {}
        if (prevCondition === 'time') {
            settings = {
                timestamp: Date.now(),
                pass: properties.pass,
                workerId: properties.workerId,
                participantId: properties.participantId,
                experiment: properties.experiment,
                condition: prevCondition,
                lowFrustration: properties.lowTime,
                mediumFrustration: properties.medTime,
                highFrustration: properties.highTime,
                additionalComments: properties.commentsTime
            }
        }

        else if (prevCondition === 'redact') {
            settings = {
                timestamp: Date.now(),
                pass: properties.pass,
                workerId: properties.workerId,
                participantId: properties.participantId,
                experiment: properties.experiment,
                condition: prevCondition,
                lowFrustration: properties.lowRedact,
                mediumFrustration: properties.medRedact,
                highFrustration: properties.highRedact,
                additionalComments: properties.commentsRedact
            }
        }

        else if (prevCondition === 'trailing') {
            settings = {
                timestamp: Date.now(),
                pass: properties.pass,
                workerId: properties.workerId,
                participantId: properties.participantId,
                experiment: properties.experiment,
                condition: prevCondition,
                lowFrustration: properties.lowSize,
                mediumFrustration: properties.medSize,
                highFrustration: properties.highSize,
                additionalComments: properties.commentsSize
            }
        }

        setPrevCondition(e);
        logAllTweakingSettings(settings);
        properties.callbacks.setCondition(e);
    }

    return (
        <div className="tweakingToolbar">
            <Flex direction="column" justifyContent={'space-between'} width={"100%"} height={"98%"}>
                <div>
                    {
                        properties.pass === 2 ?
                            <>
                                <h2 style={{ textAlign: 'center' }}>Technique</h2>
                                <ActionGroup selectionMode='single' isEmphasized={true} selectedKeys={[properties.condition]} onAction={(e) => changeCondition(e)} marginBottom={20}>
                                    <Item key='time'>Time</Item>
                                    <Item key='trailing'>Circle</Item>
                                    <Item key='redact'>Obfuscate</Item>
                                </ActionGroup>

                                <h2 style={{ textAlign: 'center' }}>Refining</h2>
                            </>

                            : <h2 style={{ textAlign: 'center' }}>Customization</h2>
                    }


                    {
                        properties.condition === 'redact' ?
                            <>
                                <h3>Obscured Text</h3>
                                <p>Select the text you want to highlight. When the mouse button is down, the document text become obfuscated. The highlight will be created when you lift your mouse and all obfuscation will be reset.</p>
                                <p>Adjust the obfuscation level to identify values that correspond to low, medium, and high levels of <b><i>frustration</i></b>. Pick values that <i>just</i> fall in that level.</p>
                                <p>You may toggle between different levels to compare and adjust your settings.</p>
                                <p>To delete a highlight, click on it, and press the black trash icon that appears. You may clear all highlights by pressing the Clear Highlights button below.</p>
                                <h4>Frustration Level</h4>
                            </> :

                            properties.condition === 'time' ?
                                <>
                                    <h3>Max Time Delay</h3>
                                    <p>Select the text you want to highlight. To create a highlight, you must keep your mouse button down and stay still for some time to fill up a gauge. If you do not wait long enough, the highlight will not be created.</p>
                                    <p>Adjust the maximum waiting time to identify values that correspond to low, medium, and high levels of <b><i>frustration</i></b>. Pick values that <i>just</i> fall in that level.</p>
                                    <p>You may toggle between different levels to compare and adjust your settings.</p>
                                    <p>To delete a highlight, click on it, and press the black trash icon that appears. You may clear all highlights by pressing the Clear Highlights button below.</p>
                                    <h4>Frustration Level</h4>
                                </> :

                                properties.condition === 'trailing' ?
                                    <>
                                        <h3>Circle Size</h3>
                                        <p>Select the text you want to highlight. When your mouse button is down, a circle will appear. You must keep your cursor within the circle the entire time while selecting to highlight text.</p>
                                        <p>Adjust the size of the circle to identify values that correspond to low, medium, and high levels of <b><i>frustration</i></b>. Pick values that <i>just</i> fall in that level.</p>
                                        <p>You may toggle between different levels to compare and adjust your settings.</p>
                                        <p>To delete a highlight, click on it, and press the black trash icon that appears. You may clear all highlights by pressing the Clear Highlights button below.</p>
                                        <h4>Frustration Level</h4>
                                    </>

                                    : null
                    }


                    <ActionGroup selectionMode='single' isEmphasized={true} defaultSelectedKeys={[properties.selectedLevel]} selectedKeys={[properties.selectedLevel]} onAction={(e) => changeFrustrationLevel(e)} marginBottom={20}>
                        <Item key='low'>Low</Item>
                        <Item key='medium'>Medium</Item>
                        <Item key='high'>High</Item>
                    </ActionGroup>

                    {
                        properties.condition === 'redact' ?
                            <>

                                {
                                    properties.selectedLevel === 'low' ? <>Low Frustration Obfuscation<br /><InputNumber value={properties.lowRedact} defaultValue={properties.lowRedact} onChange={properties.setLowRedact} min={0} max={100} style={{ width: "95%" }} variant='underlined' controls={true} step={1} formatter={(value) => `${value}% obfuscated`} parser={(value) => value?.replace('% obfuscated', '')} changeOnWheel={true} changeOnBlur={true} /></> :
                                        properties.selectedLevel === 'medium' ? <>Medium Frustration Obfuscation<br /><InputNumber value={properties.medRedact} defaultValue={properties.medRedact} onChange={properties.setMedRedact} min={0} max={100} style={{ width: "95%" }} variant='underlined' controls={true} step={1} formatter={(value) => `${value}% obfuscated`} parser={(value) => value?.replace('% obfuscated', '')} changeOnWheel={true} changeOnBlur={true} /></> :
                                            properties.selectedLevel === 'high' ? <>High Frustration Obfuscation<br /><InputNumber value={properties.highRedact} defaultValue={properties.highRedact} onChange={properties.setHighRedact} min={0} max={100} style={{ width: "95%" }} variant='underlined' controls={true} step={1} formatter={(value) => `${value}% obfuscated`} parser={(value) => value?.replace('% obfuscated', '')} changeOnWheel={true} changeOnBlur={true} /></> : null

                                }


                                <TextArea label={"Additional Comments (optional)"} width={"100%"} marginTop={20} marginBottom={20} value={properties.commentsRedact} onChange={(e) => properties.setCommentsRedact(e)}></TextArea>
                            </> :

                            properties.condition === 'time' ?
                                <>
                                    {
                                        properties.selectedLevel === 'low' ? <>Low Frustration Time Delay<br /><InputNumber value={properties.lowTime} defaultValue={properties.lowTime} onChange={properties.setLowTime} min={0} style={{ width: "95%" }} variant='underlined' controls={true} step={0.1} formatter={(value) => `${value} s`} parser={(value) => value?.replace('s', '')} changeOnWheel={true} changeOnBlur={true} /></> :
                                            properties.selectedLevel === 'medium' ? <>Medium Frustration Time Delay<br /><InputNumber value={properties.medTime} defaultValue={properties.medTime} onChange={properties.setMedTime} min={0} style={{ width: "95%" }} variant='underlined' controls={true} step={0.1} formatter={(value) => `${value} s`} parser={(value) => value?.replace('s', '')} changeOnWheel={true} changeOnBlur={true} /></> :
                                                properties.selectedLevel === 'high' ? <>High Frustration Time Delay<br /><InputNumber value={properties.highTime} defaultValue={properties.highTime} onChange={properties.setHighTime} min={0} style={{ width: "95%" }} variant='underlined' controls={true} step={0.1} formatter={(value) => `${value} s`} parser={(value) => value?.replace('s', '')} changeOnWheel={true} changeOnBlur={true} /></> : null
                                    }

                                    <TextArea label={"Additional Comments (optional)"} width={"100%"} marginTop={20} marginBottom={20} value={properties.commentsTime} onChange={(e) => properties.setCommentsTime(e)}></TextArea>
                                </> :

                                properties.condition === 'trailing' ?
                                    <>
                                        {
                                            properties.selectedLevel === 'low' ? <>Low Frustration Circle Size<br /><InputNumber value={properties.lowSize} defaultValue={properties.lowSize} onChange={properties.setLowSize} min={10} style={{ width: "95%" }} variant='underlined' controls={true} step={1} formatter={(value) => `${value} px`} parser={(value) => value?.replace('px', '')} changeOnWheel={true} changeOnBlur={true} /></> :
                                                properties.selectedLevel === 'medium' ? <>Medium Frustration Circle Size<br /><InputNumber value={properties.medSize} defaultValue={properties.medSize} onChange={properties.setMedSize} min={10} style={{ width: "95%" }} variant='underlined' controls={true} step={1} formatter={(value) => `${value} px`} parser={(value) => value?.replace('px', '')} changeOnWheel={true} changeOnBlur={true} /></> :
                                                    properties.selectedLevel === 'high' ? <>High Frustration Circle Size<br /><InputNumber value={properties.highSize} defaultValue={properties.highSize} onChange={properties.setHighSize} min={10} style={{ width: "95%" }} variant='underlined' controls={true} step={1} formatter={(value) => `${value} px`} parser={(value) => value?.replace('px', '')} changeOnWheel={true} changeOnBlur={true} /></> : null
                                        }

                                        <TextArea label={"Additional Comments (optional)"} width={"100%"} marginTop={20} marginBottom={20} value={properties.commentsSize} onChange={(e) => properties.setCommentsSize(e)}></TextArea>
                                    </>

                                    : null
                    }

                    <Button variant='cta' width={"100%"} onPress={() => properties.setHighlights([])}>Clear Highlights</Button>

                </div>



                <DialogTrigger>
                    <Button variant='cta'>Confirm</Button>
                    <AlertDialog
                        variant='information'
                        primaryActionLabel='Confirm'
                        cancelLabel='Cancel'
                        title='Submit Settings'
                        onPrimaryAction={() => submitSettings()}>
                        Are you sure you want to submit these settings? {properties.pass === 2 ? (<b>This will finalize your settings for the experiment.</b>) : "You will be able to adjust these settings later."}
                    </AlertDialog>
                </DialogTrigger>



            </Flex>


        </div>
    );
}

export default TweakingToolbar;